var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-box"},[_c('div',[_c('p',{staticClass:"nickname"},[_vm._v("欢迎登陆「"+_vm._s(_vm.userInfo.admin.name)+"」")]),_c('p',[_vm._v(_vm._s(_vm.ADMIN_TITLE))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }